<template>
  <div class="controls" :class="{ 'portrait-mode': isPortraitMode }">
    <!-- 总结按钮 -->
    <button
      class="control-btn summary-btn"
      @click="$emit('summarize')"
      :disabled="!isConnected"
      title="总结对话"
    >
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
        <path
          fill="currentColor"
          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6v12H6V2h8zM10 14H8v-2h2v2zm0-4H8V6h2v4zm4 4h-2v-2h2v2zm0-4h-2V6h2v4z"
        />
      </svg>
    </button>

    <!-- 毛玻璃按钮卡片栏 -->
    <div
      class="glass-button-bar"
      :class="{ 'tech-bar': !isConnected, portrait: isPortraitMode }"
    >
      <!-- 科技感卡片栏特效（仅未连接时显示） -->
      <template v-if="!isConnected">
        <div class="tech-bar-ring"></div>
        <div class="tech-bar-glow"></div>
        <div class="tech-bar-scan"></div>
        <div class="tech-bar-dots">
          <span></span><span></span><span></span><span></span><span></span
          ><span></span>
        </div>
      </template>

      <!-- 打断按钮 -->
      <button
        v-if="isConnected"
        class="control-btn interrupt-btn"
        @click="$emit('interrupt')"
        :disabled="!isConnected"
        title="打断"
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
          <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" />
        </svg>
      </button>

      <!-- 闭麦按钮 -->
      <button
        v-if="isConnected"
        class="control-btn microphone-btn"
        @click="$emit('toggle-microphone')"
        :disabled="!isConnected"
        :class="{ active: !isMicrophoneMuted }"
        title="麦克风"
      >
        <svg
          v-if="isMicrophoneMuted"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="none"
        >
          <path
            fill="currentColor"
            d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
          />
        </svg>
        <svg v-else viewBox="0 0 24 24" width="24" height="24" fill="none">
          <path
            fill="currentColor"
            d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z"
          />
        </svg>
      </button>

      <!-- 开启/结束视频通话按钮 -->
      <button
        v-if="!isConnected"
        class="video-call-btn tech-btn"
        :class="{ loading: isConnecting }"
        @click="$emit('connect')"
        :disabled="isConnecting"
        title="开启视频通话"
      >
        <!-- 科技感特效层 -->
        <div class="tech-ring tech-ring-1"></div>
        <div class="tech-ring tech-ring-2"></div>
        <div class="tech-ring tech-ring-3"></div>
        <div class="tech-core"></div>
        <div class="tech-glow"></div>
        <div class="tech-scan"></div>
        <div class="tech-dots">
          <span></span><span></span><span></span><span></span><span></span
          ><span></span>
        </div>
        <div class="btn-content">
          <svg
            class="tech-icon"
            viewBox="0 0 64 64"
            width="28"
            height="28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="techGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" style="stop-color: #00d4ff" />
                <stop offset="50%" style="stop-color: #0099ff" />
                <stop offset="100%" style="stop-color: #0066ff" />
              </linearGradient>
              <linearGradient
                id="techGradient2"
                x1="0%"
                y1="100%"
                x2="100%"
                y2="0%"
              >
                <stop offset="0%" style="stop-color: #66e0ff" />
                <stop offset="100%" style="stop-color: #00b3ff" />
              </linearGradient>
              <filter
                id="techGlow"
                x="-50%"
                y="-50%"
                width="200%"
                height="200%"
              >
                <feGaussianBlur stdDeviation="2" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g filter="url(#techGlow)">
              <rect
                x="8"
                y="18"
                width="32"
                height="28"
                rx="4"
                fill="url(#techGradient)"
                class="camera-body"
              />
              <rect
                x="10"
                y="20"
                width="28"
                height="24"
                rx="2"
                fill="rgba(0,0,0,0.4)"
              />
              <circle
                cx="24"
                cy="32"
                r="8"
                fill="none"
                stroke="url(#techGradient2)"
                stroke-width="2"
                class="lens-ring"
              />
              <circle
                cx="24"
                cy="32"
                r="5"
                fill="url(#techGradient)"
                class="lens-core"
              />
              <circle
                cx="22"
                cy="30"
                r="2"
                fill="rgba(255,255,255,0.9)"
                class="lens-highlight"
              />
              <path
                d="M40 24 L50 20 L50 44 L40 40 Z"
                fill="url(#techGradient)"
                class="camera-side"
              />
              <path d="M40 26 L48 22 L48 42 L40 38 Z" fill="rgba(0,0,0,0.3)" />
            </g>
          </svg>
          <span v-if="isConnecting" class="loading-text">connecting...</span>
        </div>
      </button>

      <button
        v-else
        class="end-call-btn"
        @click="$emit('disconnect')"
        title="结束通话"
      >
        <div class="btn-glow end-glow"></div>
        <div class="btn-glow-ring end-ring"></div>
        <svg
          viewBox="0 0 64 64"
          width="32"
          height="32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="redGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" style="stop-color: #ff5252" />
              <stop offset="50%" style="stop-color: #ff1744" />
              <stop offset="100%" style="stop-color: #d50000" />
            </linearGradient>
            <filter id="redGlow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g filter="url(#redGlow)">
            <path
              d="M12 24 C12 20, 16 16, 22 16 L42 16 C48 16, 52 20, 52 24 L52 40 C52 44, 48 48, 42 48 L22 48 C16 48, 12 44, 12 40 Z"
              fill="url(#redGradient)"
            />
            <rect
              x="16"
              y="22"
              width="16"
              height="20"
              rx="2"
              fill="rgba(0,0,0,0.3)"
            />
            <circle cx="24" cy="32" r="5" fill="rgba(255,255,255,0.2)" />
            <path d="M36 26 L44 22 L44 42 L36 38 Z" fill="rgba(0,0,0,0.3)" />
            <line
              x1="20"
              y1="20"
              x2="44"
              y2="44"
              stroke="#fff"
              stroke-width="3"
              stroke-linecap="round"
            />
          </g>
        </svg>
      </button>

      <!-- 音量调节按钮 -->
      <div
        v-if="isConnected"
        class="volume-wrapper"
        :class="{ portrait: isPortraitMode }"
      >
        <input
          type="range"
          min="0"
          max="100"
          :value="volume"
          @input="handleVolumeInput"
          class="volume-slider"
        />
        <button
          class="control-btn volume-btn"
          @click="$emit('toggle-volume-mute')"
          :disabled="!isConnected"
          title="音量"
        >
          <svg
            v-if="isVolumeMuted || volume === 0"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
          >
            <path
              fill="currentColor"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4l-2.28 2.28L12 8.56z"
            />
          </svg>
          <svg v-else viewBox="0 0 24 24" width="24" height="24" fill="none">
            <path
              fill="currentColor"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- 总结和退出登录按钮 -->
    <div class="extra-buttons" :class="{ portrait: isPortraitMode }">
      <!-- 退出登录按钮 -->
      <button
        class="control-btn logout-btn"
        @click="$emit('logout')"
        title="退出登录"
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
          <path
            fill="currentColor"
            d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5z"
          />
          <path
            fill="currentColor"
            d="M4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * 控制面板组件
 * 负责显示连接和断开连接按钮，以及其他控制功能
 */
export default defineComponent({
  name: 'ControlsPanel',
  props: {
    /**
     * 是否已连接到实时服务
     */
    isConnected: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否正在连接中
     */
    isConnecting: {
      type: Boolean,
      default: false,
    },
    /**
     * 麦克风是否静音
     */
    isMicrophoneMuted: {
      type: Boolean,
      default: false,
    },
    /**
     * 音量是否静音
     */
    isVolumeMuted: {
      type: Boolean,
      default: false,
    },
    /**
     * 音量大小
     */
    volume: {
      type: Number,
      default: 100,
    },
    /**
     * 是否为竖屏模式
     */
    isPortraitMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * 连接事件
     */
    'connect',
    /**
     * 断开连接事件
     */
    'disconnect',
    /**
     * 切换麦克风状态事件
     */
    'toggle-microphone',
    /**
     * 切换音量静音状态事件
     */
    'toggle-volume-mute',
    /**
     * 音量变化事件
     */
    'volume-change',
    /**
     * 打断对话事件
     */
    'interrupt',
    /**
     * 总结对话事件
     */
    'summarize',
    /**
     * 退出登录事件
     */
    'logout',
  ],
  methods: {
    /**
     * 处理音量输入变化
     * @param event 输入事件
     */
    handleVolumeInput(event: Event) {
      const target = event.target as HTMLInputElement;
      const value = Number(target.value);
      if (process.env.NODE_ENV === 'development') {
        console.log('Volume slider changed to:', value);
      }
      this.$emit('volume-change', value);
    },
  },
});
</script>

<style scoped>
.controls {
  padding: 20px 30px;
  z-index: 10;
  margin-top: -10px;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: none;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  min-height: 104px;
  transition: all 0.3s ease;
}

/* 竖屏模式下的控制栏样式 */
.controls.portrait-mode {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  margin-top: 0;
  z-index: 99;
  flex-direction: column;
}

/* 毛玻璃按钮卡片栏 */
.glass-button-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 50px;
  box-shadow:
    0 4px 20px rgba(0, 80, 180, 0.12),
    0 0 30px rgba(0, 184, 217, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 184, 217, 0.3);
  height: 64px;
  min-height: 64px;
  max-height: 64px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  animation: barTechAppear 1.2s ease-out forwards;
  position: relative;
}

/* 竖屏模式下的按钮栏样式 */
.glass-button-bar.portrait {
  flex-direction: column;
  height: auto;
  min-height: unset;
  max-height: unset;
  padding: 16px;
  gap: 12px;
  border-radius: 20px;
}

/* 竖屏模式下的音量控制 */
.volume-wrapper.portrait {
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.volume-wrapper.portrait .volume-slider {
  width: 40px;
  height: 80px;
  writing-mode: bt-lr;
  -webkit-appearance: slider-vertical;
}

.volume-wrapper.portrait .volume-slider::-webkit-slider-thumb {
  width: 14px;
  height: 14px;
}

.volume-wrapper.portrait .volume-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
}

/* 卡片栏从隐形到出现的科技感动画 */
@keyframes barTechAppear {
  0% {
    opacity: 0;
    filter: blur(15px);
    box-shadow:
      0 0 0 rgba(0, 184, 217, 0),
      inset 0 0 0 rgba(0, 184, 217, 0);
  }
  30% {
    opacity: 0.3;
    filter: blur(8px);
    box-shadow:
      0 0 30px rgba(0, 184, 217, 0.25),
      inset 0 0 20px rgba(0, 184, 217, 0.12);
  }
  60% {
    opacity: 0.7;
    filter: blur(3px);
    box-shadow:
      0 4px 20px rgba(0, 80, 180, 0.12),
      0 0 50px rgba(0, 184, 217, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.9),
      inset 0 0 30px rgba(0, 184, 217, 0.08);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    box-shadow:
      0 4px 20px rgba(0, 80, 180, 0.12),
      0 0 20px rgba(0, 184, 217, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.9),
      inset 0 0 10px rgba(0, 184, 217, 0.04);
  }
}

/* 未连接时的科技感微圆形卡片栏 */
.glass-button-bar.tech-bar {
  padding: 8px;
  border-radius: 50%;
  min-height: auto;
  min-width: auto;
  height: auto;
  max-height: none;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: none;
  box-shadow: none;
  position: relative;
}

/* 科技感卡片栏核心 */
.glass-button-bar.tech-bar::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background:
    radial-gradient(
      circle at 30% 30%,
      rgba(0, 184, 217, 0.06) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 70%,
      rgba(0, 136, 255, 0.06) 0%,
      transparent 50%
    ),
    linear-gradient(
      135deg,
      rgba(0, 184, 217, 0.02) 0%,
      rgba(0, 136, 255, 0.02) 100%
    );
  border: 1px solid rgba(0, 184, 217, 0.2);
  box-shadow:
    inset 0 0 30px rgba(0, 184, 217, 0.06),
    0 0 30px rgba(0, 184, 217, 0.1);
  animation: techBarPulse 2.5s ease-in-out infinite;
  z-index: -1;
}

/* 科技感卡片栏旋转环 */
.glass-button-bar.tech-bar::after {
  content: '';
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 1px solid rgba(0, 184, 217, 0.35);
  border-top-color: transparent;
  border-bottom-color: transparent;
  animation: techBarRotate 5s linear infinite;
  pointer-events: none;
}

/* 科技感卡片栏装饰环 */
.glass-button-bar.tech-bar .tech-bar-ring {
  position: absolute;
  inset: -12px;
  border-radius: 50%;
  border: 1px dashed rgba(0, 136, 255, 0.2);
  animation: techBarRotate 8s linear infinite reverse;
  pointer-events: none;
}

/* 科技感卡片栏光晕 */
.glass-button-bar.tech-bar .tech-bar-glow {
  position: absolute;
  inset: -25px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(0, 184, 217, 0.08) 0%,
    rgba(0, 136, 255, 0.04) 40%,
    transparent 70%
  );
  animation: techBarGlow 3s ease-in-out infinite;
  pointer-events: none;
}

/* 科技感卡片栏扫描线 */
.glass-button-bar.tech-bar .tech-bar-scan {
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  background: linear-gradient(
    180deg,
    transparent 45%,
    rgba(0, 184, 217, 0.2) 50%,
    transparent 55%
  );
  animation: techBarScan 2.5s ease-in-out infinite;
  pointer-events: none;
}

/* 科技感卡片栏发光点 */
.glass-button-bar.tech-bar .tech-bar-dots {
  position: absolute;
  inset: -15px;
  pointer-events: none;
}

.glass-button-bar.tech-bar .tech-bar-dots span {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #00b8d9;
  border-radius: 50%;
  box-shadow: 0 0 8px #00b8d9;
  animation: techBarDot 2s ease-in-out infinite;
}

.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(1) {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0s;
}
.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(2) {
  top: 20%;
  right: 5%;
  animation-delay: 0.25s;
}
.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(3) {
  bottom: 20%;
  right: 5%;
  animation-delay: 0.5s;
}
.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(4) {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0.75s;
}
.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(5) {
  bottom: 20%;
  left: 5%;
  animation-delay: 1s;
}
.glass-button-bar.tech-bar .tech-bar-dots span:nth-child(6) {
  top: 20%;
  left: 5%;
  animation-delay: 1.25s;
}

/* 科技感卡片栏动画 */
@keyframes techBarPulse {
  0%,
  100% {
    box-shadow:
      inset 0 0 30px rgba(0, 184, 217, 0.06),
      0 0 30px rgba(0, 184, 217, 0.1);
  }
  50% {
    box-shadow:
      inset 0 0 40px rgba(0, 184, 217, 0.1),
      0 0 40px rgba(0, 184, 217, 0.2);
  }
}

@keyframes techBarRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes techBarGlow {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes techBarScan {
  0% {
    transform: rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: rotate(360deg);
    opacity: 0;
  }
}

@keyframes techBarDot {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.4);
  }
}

.control-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 80, 180, 0.1);
  flex-shrink: 0;
  animation: btnTechAppear 0.9s ease-out forwards;
}

/* 按钮从隐形到出现的科技感动画 */
@keyframes btnTechAppear {
  0% {
    opacity: 0;
    filter: blur(12px);
    box-shadow: 0 0 0 rgba(0, 212, 255, 0);
    transform: translateY(10px);
  }
  40% {
    opacity: 0.4;
    filter: blur(6px);
    box-shadow: 0 0 20px rgba(0, 212, 255, 0.4);
    transform: translateY(-5px);
  }
  70% {
    opacity: 0.8;
    filter: blur(2px);
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.5),
      0 0 35px rgba(0, 212, 255, 0.3);
    transform: translateY(2px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    box-shadow:
      0 2px 8px rgba(0, 0, 0, 0.5),
      0 0 15px rgba(0, 212, 255, 0.15);
    transform: translateY(0);
  }
}

/* 按钮科技感光晕脉冲 */
.control-btn::before {
  content: '';
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(0, 184, 217, 0.2) 0%,
    rgba(0, 136, 255, 0.08) 40%,
    transparent 70%
  );
  opacity: 0;
  animation: btnGlowPulse 1.8s ease-in-out infinite;
  z-index: -1;
  pointer-events: none;
}

@keyframes btnGlowPulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.15);
  }
}

/* 按钮科技感边框光效 */
.control-btn::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid transparent;
  background: conic-gradient(
    from 0deg,
    transparent 0%,
    rgba(0, 184, 217, 0.5) 25%,
    rgba(0, 136, 255, 0.5) 50%,
    rgba(0, 184, 217, 0.5) 75%,
    transparent 100%
  );
  background-clip: padding-box;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0;
  animation: btnBorderPulse 2s ease-in-out infinite;
  z-index: -1;
  pointer-events: none;
}

@keyframes btnBorderPulse {
  0%,
  100% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.5;
  }
}

.control-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 80, 180, 0.15);
  background: rgba(255, 255, 255, 0.95);
  color: var(--accent-cyan, #00b8d9);
}

.control-btn:active:not(:disabled) {
  transform: translateY(0);
}

.control-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.control-btn.microphone-btn.active {
  background: linear-gradient(
    135deg,
    rgba(0, 184, 217, 0.15) 0%,
    rgba(124, 58, 237, 0.15) 100%
  );
  color: var(--accent-cyan, #00b8d9);
  box-shadow:
    0 2px 8px rgba(0, 184, 217, 0.2),
    0 0 15px rgba(0, 184, 217, 0.1);
}

.interrupt-btn:hover:not(:disabled) {
  background: linear-gradient(
    135deg,
    rgba(255, 77, 79, 0.15) 0%,
    rgba(255, 77, 79, 0.15) 100%
  );
  color: var(--error-color, #ff4d4f);
  box-shadow:
    0 2px 8px rgba(255, 77, 79, 0.2),
    0 0 15px rgba(255, 77, 79, 0.1);
}

/* 音量控制包装器 */
.volume-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row-reverse;
}

.volume-slider {
  width: 80px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(0, 212, 255, 0.2);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00d4ff, #8b5cf6);
  cursor: pointer;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.5),
    0 0 10px rgba(0, 212, 255, 0.3);
  transition: all 0.2s;
}

.volume-slider::-webkit-slider-thumb:hover {
  transform: scale(1.15);
  box-shadow:
    0 3px 10px rgba(0, 0, 0, 0.5),
    0 0 15px rgba(0, 212, 255, 0.4);
}

.volume-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00d4ff, #8b5cf6);
  cursor: pointer;
  border: none;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.5),
    0 0 10px rgba(0, 212, 255, 0.3);
  transition: all 0.2s;
}

.volume-slider::-moz-range-thumb:hover {
  transform: scale(1.15);
}

/* 视频通话按钮 - 科技感微圆形 */
.video-call-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  flex-shrink: 0;
}

/* 科技感特效 */
.tech-btn .tech-core {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background:
    radial-gradient(
      circle at 30% 30%,
      rgba(0, 212, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 70%,
      rgba(0, 102, 255, 0.1) 0%,
      transparent 50%
    ),
    linear-gradient(
      135deg,
      rgba(0, 212, 255, 0.05) 0%,
      rgba(0, 102, 255, 0.05) 100%
    );
  border: 1px solid rgba(0, 212, 255, 0.3);
  box-shadow:
    inset 0 0 20px rgba(0, 212, 255, 0.1),
    0 0 20px rgba(0, 212, 255, 0.2);
  animation: techPulse 2s ease-in-out infinite;
}

.tech-btn .tech-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid transparent;
  pointer-events: none;
}

.tech-btn .tech-ring-1 {
  inset: -4px;
  border-color: rgba(0, 212, 255, 0.6);
  animation: techRotate 4s linear infinite;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.tech-btn .tech-ring-2 {
  inset: -8px;
  border-color: rgba(0, 153, 255, 0.4);
  animation: techRotate 6s linear infinite reverse;
  border-left-color: transparent;
  border-right-color: transparent;
}

.tech-btn .tech-ring-3 {
  inset: -12px;
  border: 1px dashed rgba(0, 212, 255, 0.2);
  animation: techRotate 8s linear infinite;
}

.tech-btn .tech-glow {
  position: absolute;
  inset: -20px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(0, 212, 255, 0.15) 0%,
    rgba(0, 102, 255, 0.05) 40%,
    transparent 70%
  );
  animation: techGlow 3s ease-in-out infinite;
  pointer-events: none;
}

.tech-btn .tech-scan {
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background: linear-gradient(
    180deg,
    transparent 40%,
    rgba(0, 212, 255, 0.3) 50%,
    transparent 60%
  );
  animation: techScan 2s ease-in-out infinite;
  pointer-events: none;
}

.tech-btn .tech-dots {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.tech-btn .tech-dots span {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #00d4ff;
  border-radius: 50%;
  box-shadow: 0 0 6px #00d4ff;
  animation: techDot 2s ease-in-out infinite;
}

.tech-btn .tech-dots span:nth-child(1) {
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0s;
}
.tech-btn .tech-dots span:nth-child(2) {
  top: 25%;
  right: 10%;
  animation-delay: 0.3s;
}
.tech-btn .tech-dots span:nth-child(3) {
  bottom: 25%;
  right: 10%;
  animation-delay: 0.6s;
}
.tech-btn .tech-dots span:nth-child(4) {
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0.9s;
}
.tech-btn .tech-dots span:nth-child(5) {
  bottom: 25%;
  left: 10%;
  animation-delay: 1.2s;
}
.tech-btn .tech-dots span:nth-child(6) {
  top: 25%;
  left: 10%;
  animation-delay: 1.5s;
}

.btn-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tech-icon {
  filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.6));
  animation: techIconFloat 3s ease-in-out infinite;
}

.tech-btn:hover {
  transform: translateY(-2px) scale(1.05);
}

.tech-btn:hover .tech-core {
  background:
    radial-gradient(
      circle at 30% 30%,
      rgba(0, 212, 255, 0.2) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 70%,
      rgba(0, 102, 255, 0.2) 0%,
      transparent 50%
    ),
    linear-gradient(
      135deg,
      rgba(0, 212, 255, 0.1) 0%,
      rgba(0, 102, 255, 0.1) 100%
    );
  border-color: rgba(0, 212, 255, 0.5);
  box-shadow:
    inset 0 0 30px rgba(0, 212, 255, 0.15),
    0 0 30px rgba(0, 212, 255, 0.3);
}

.tech-btn:hover .tech-ring-1 {
  animation-duration: 2s;
}

.tech-btn:hover .tech-ring-2 {
  animation-duration: 3s;
}

.tech-btn:active {
  transform: translateY(0) scale(1.02);
}

.video-call-btn.loading {
  animation: none;
}

.video-call-btn.loading .tech-core {
  animation:
    techPulse 1s ease-in-out infinite,
    techLoading 1.5s ease-in-out infinite;
}

.video-call-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 科技感动画 */
@keyframes techPulse {
  0%,
  100% {
    box-shadow:
      inset 0 0 20px rgba(0, 212, 255, 0.1),
      0 0 20px rgba(0, 212, 255, 0.2);
  }
  50% {
    box-shadow:
      inset 0 0 30px rgba(0, 212, 255, 0.15),
      0 0 30px rgba(0, 212, 255, 0.3);
  }
}

@keyframes techRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes techGlow {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

@keyframes techScan {
  0% {
    transform: rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: rotate(360deg);
    opacity: 0;
  }
}

@keyframes techDot {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}

@keyframes techIconFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

@keyframes techLoading {
  0%,
  100% {
    border-color: rgba(0, 212, 255, 0.3);
  }
  50% {
    border-color: rgba(0, 212, 255, 0.8);
  }
}

/* 结束通话按钮 */
.end-call-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 30%,
    #3a1a1a 0%,
    #1f0d0d 50%,
    #150808 100%
  );
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  box-shadow:
    0 0 20px rgba(255, 82, 82, 0.15),
    inset 0 0 30px rgba(255, 82, 82, 0.05);
  flex-shrink: 0;
  animation: endBtnTechAppear 1s ease-out forwards;
}

/* 结束按钮从隐形到出现的科技感动画 */
@keyframes endBtnTechAppear {
  0% {
    opacity: 0;
    filter: blur(18px);
    box-shadow: 0 0 0 rgba(255, 82, 82, 0);
    transform: translateY(15px);
  }
  35% {
    opacity: 0.35;
    filter: blur(10px);
    box-shadow: 0 0 25px rgba(255, 82, 82, 0.4);
    transform: translateY(-8px);
  }
  70% {
    opacity: 0.8;
    filter: blur(4px);
    box-shadow:
      0 0 20px rgba(255, 82, 82, 0.15),
      0 0 45px rgba(255, 82, 82, 0.3),
      inset 0 0 30px rgba(255, 82, 82, 0.05);
    transform: translateY(3px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    box-shadow:
      0 0 20px rgba(255, 82, 82, 0.15),
      0 0 20px rgba(255, 82, 82, 0.15),
      inset 0 0 30px rgba(255, 82, 82, 0.05);
    transform: translateY(0);
  }
}

/* 结束按钮科技感能量光晕 */
.end-call-btn .end-glow {
  position: absolute;
  inset: -18px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 82, 82, 0.25) 0%,
    rgba(255, 23, 68, 0.12) 40%,
    transparent 70%
  );
  opacity: 0;
  animation: endGlowPulse 2s ease-in-out infinite;
  z-index: -2;
}

@keyframes endGlowPulse {
  0%,
  100% {
    opacity: 0.35;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.18);
  }
}

/* 结束按钮科技感边框脉冲 */
.end-call-btn::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid transparent;
  background: conic-gradient(
    from 0deg,
    transparent 0%,
    rgba(255, 82, 82, 0.6) 25%,
    rgba(255, 23, 68, 0.6) 50%,
    rgba(255, 82, 82, 0.6) 75%,
    transparent 100%
  );
  background-clip: padding-box;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0;
  animation: endBorderPulse 1.8s ease-in-out infinite;
  z-index: -1;
  pointer-events: none;
}

@keyframes endBorderPulse {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.65;
  }
}

/* 结束按钮科技感内发光 */
.end-call-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%
  );
  opacity: 0;
  animation: endInnerGlow 2.2s ease-in-out infinite;
  z-index: -1;
  pointer-events: none;
}

@keyframes endInnerGlow {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
}

.end-call-btn:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow:
    0 0 30px rgba(255, 82, 82, 0.25),
    inset 0 0 40px rgba(255, 82, 82, 0.08);
}

.end-call-btn:active {
  transform: translateY(-1px) scale(1.01);
}

.loading-text {
  font-size: 10px;
  margin-top: 2px;
  font-weight: 600;
  color: #00ff88;
  text-shadow: 0 0 15px rgba(0, 255, 136, 0.6);
  letter-spacing: 1px;
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes glowPulse {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.08);
  }
}

@keyframes glowPulseHover {
  0%,
  100% {
    opacity: 0.8;
    transform: scale(1.08);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}

@keyframes ringExpand {
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

@keyframes particle {
  0%,
  100% {
    transform: scale(1) translateY(0);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.5) translateY(-8px);
    opacity: 1;
  }
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

@keyframes cameraPulse {
  0%,
  100% {
    filter: drop-shadow(0 0 2px #00ff88);
  }
  50% {
    filter: drop-shadow(0 0 6px #00ff88);
  }
}

@keyframes lensRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes lensPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

@keyframes highlightShine {
  0%,
  100% {
    opacity: 0.9;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes signalBurst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

@keyframes loadingPulse {
  0%,
  100% {
    box-shadow: 0 0 25px rgba(0, 255, 136, 0.2);
  }
  50% {
    box-shadow: 0 0 45px rgba(0, 255, 136, 0.4);
  }
}

/* 总结和退出登录按钮容器 */
.extra-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

/* 竖屏模式下的额外按钮 */
.extra-buttons.portrait {
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

/* 总结按钮样式 */
.summary-btn:hover:not(:disabled) {
  background: linear-gradient(
    135deg,
    rgba(0, 185, 107, 0.2) 0%,
    rgba(0, 212, 255, 0.15) 100%
  );
  color: var(--success-color, #00b96b);
  box-shadow:
    0 2px 8px rgba(0, 185, 107, 0.3),
    0 0 15px rgba(0, 185, 107, 0.15);
}

/* 退出登录按钮样式 */
.logout-btn:hover:not(:disabled) {
  background: linear-gradient(
    135deg,
    rgba(255, 82, 82, 0.2) 0%,
    rgba(168, 85, 247, 0.15) 100%
  );
  color: var(--error-color, #ff5252);
  box-shadow:
    0 2px 8px rgba(255, 82, 82, 0.3),
    0 0 15px rgba(255, 82, 82, 0.15);
}

/* 响应式适配 */
@media (max-width: 480px) {
  .controls {
    gap: 12px;
    min-height: 84px;
    padding: 14px 18px;
  }

  .controls.portrait-mode {
    left: 10px;
    padding: 6px;
  }

  .glass-button-bar {
    padding: 7px 12px;
    gap: 8px;
    height: 52px;
    min-height: 52px;
    max-height: 52px;
  }

  .glass-button-bar.portrait {
    padding: 10px;
    gap: 8px;
  }

  .control-btn {
    width: 34px;
    height: 34px;
  }

  .control-btn svg {
    width: 18px;
    height: 18px;
  }

  .video-call-btn {
    width: 38px;
    height: 38px;
  }

  .video-call-btn .tech-icon {
    width: 22px;
    height: 22px;
  }

  .end-call-btn {
    width: 40px;
    height: 40px;
  }

  .end-call-btn svg {
    width: 24px;
    height: 24px;
  }

  .volume-slider {
    width: 48px;
  }

  .tech-btn .tech-ring-1 {
    inset: -3px;
  }
  .tech-btn .tech-ring-2 {
    inset: -6px;
  }
  .tech-btn .tech-ring-3 {
    inset: -9px;
  }

  .extra-buttons {
    gap: 8px;
    margin-top: 8px;
  }
}
</style>
